import React from "react";
import { Redirect } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import { gql } from "apollo-boost";
import NewServiceForm from "./NewServiceForm";
import FullScreenModal from "../FullScreenModal";
import JobServicesQuery from "../../queries/JobServices";
import { buildRoute } from "../../routes";
import { addToCache } from "../../utils/queryHelpers";

class NewService extends React.Component {
  state = {
    newServiceId: null
  };

  submit = values => {
    return this.props
      .createService({ input: values })
      .then(({ data: { createService } }) => {
        this.setState({ newServiceId: createService.id });
      })
      .catch(err => {
        console.error("there was a problem creating this service", err);
      });
  };

  render() {
    const { history, location, match } = this.props;

    if (this.state.newServiceId !== null) {
      const { match: { url, params: { jobId } } } = this.props;
      const route = buildRoute(
        url,
        `/jobs/${jobId}/services/${this.state.newServiceId}`
      );
      return <Redirect to={route} push />;
    }

    return (
      <FullScreenModal
        isOpen
        close={() =>
          location.state && location.state.goBack
            ? history.goBack()
            : history.push(match.url.replace("/new", ""))
        }
      >
        <NewServiceForm
          franchiseSlug={match.params.franchiseSlug}
          onSubmit={this.submit}
        />
      </FullScreenModal>
    );
  }
}

const CreateServiceMutation = gql`
  mutation CreateServiceMutation($input: ServiceInput!) {
    createService(input: $input) {
      id
      serviceType
      status
      holdType
      holdReason
      updatedAt
    }
  }
`;

const enhance = compose(
  graphql(CreateServiceMutation, {
    props: ({ ownProps: { match: { params: { jobId } } }, mutate }) => ({
      createService: ({ input }) => {
        return mutate({
          variables: { input: { ...input, jobId } },
          update: (store, { data: { createService } }) => {
            addToCache(createService, store, "services", {
              query: JobServicesQuery,
              variables: { jobId }
            });
          }
        });
      }
    })
  })
);

export default enhance(NewService);



// WEBPACK FOOTER //
// ./src/components/services/NewService.js